const state = {
  data: [],
  loadError: false,
  isLoading: false
};

const mutations = {
  receive_discount_types(state, roles) {
    state.data = roles;
  },
  set_load_error(state, loadError) {
    state.loadError = loadError;
  },
  set_is_loading(state, isLoading) {
    state.isLoading = isLoading;
  }
};

const actions = {
  async getDiscountTypes({ state, commit }) {
    if (!state.data.length || state.loadError) {
      commit('set_is_loading', true);
      try {
        axios.post('/api/discounts/get-discounts')
        .then(response => {
          commit('set_load_error', false);
          commit('set_is_loading', false);
          commit('receive_discount_types', response.data.data);
        })
      } catch (error) {
        console.log('error while loading discount types', error);
        commit('set_load_error', true);
        commit('set_is_loading', false);
      }
    }

    return state;
  }
};

const getters = {
  allDiscountTypes (state) {
    return state
  }
};

export default ({
  state,
  actions,
  mutations,
  getters
});
